import { EnvironmentProviders, makeEnvironmentProviders, Provider } from '@angular/core';

import {
  provideTellentAssistantAuthTokenGetter,
  provideTellentAssistantConfig,
  type TellentAssistantConfig,
} from '@core/tellent-assistant-contracts';

export interface TellentAssistantOptions {
  config: TellentAssistantConfig;
  authTokenGetter: () => string | null;
  extraProviders?: Provider[];
}

export function provideTellentAssistant(opts: TellentAssistantOptions): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideTellentAssistantConfig({ useValue: opts.config }),
    provideTellentAssistantAuthTokenGetter({ useValue: opts.authTokenGetter }),
    ...(opts.extraProviders ?? []),
  ]);
}
